//
// OS.js client configuration.
// Complete config tree: https://github.com/os-js/osjs-client/blob/master/src/config.js
//
// `standalone: true` runs OS.js entirely in the browser with NO backend server:
//   - WebSocket connection is disabled
//   - HTTP requests to the OS.js API are blocked
//   - The VFS and Settings/Auth fall back to local (in-browser) adapters
//
// `auth.login.username` + `auth.login.password` make the client auto-login,
// so the desktop boots straight away instead of showing the login screen.
//

export default {
  standalone: true,
  auth: {
    login: {
      username: 'demo',
      password: 'demo'
    }
  }
};
